import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import ErrorComponent from '@/components/error';
import useEntityId from '@/entities/components/details/hooks/use-entity-id';
import type { Subsection } from '../../../../onboarding-data.types';
import type { BusinessInsightDisplayOptions } from '../../onboarding-business-insight';
import BusinessDetails from './components/business-details';
import Loading from './components/loading';
import Offices from './components/offices';
import People from './components/people';
import RegistrationDetails from './components/registration-details';
import Registrations from './components/registrations';
import Watchlist from './components/watchlist';
import useOnboardingBusinessInsights from './hooks/use-onboarding-business-insights';
export type DecryptedContentProps = {
  onboardingId: string;
  selectedSubsection: Subsection;
  displayOptions?: BusinessInsightDisplayOptions;
};
const DecryptedContent = t0 => {
  const $ = _c(38);
  const {
    onboardingId,
    selectedSubsection,
    displayOptions
  } = t0;
  const [openRegistrationId, setOpenRegistrationId] = useState(undefined);
  const entityId = useEntityId();
  const {
    isPending,
    error,
    data: insights
  } = useOnboardingBusinessInsights(entityId, onboardingId);
  let t1;
  if ($[0] !== insights?.registrations || $[1] !== openRegistrationId) {
    t1 = insights?.registrations.find(r => r.id === openRegistrationId);
    $[0] = insights?.registrations;
    $[1] = openRegistrationId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const openRegistration = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = registrationId => {
      setOpenRegistrationId(registrationId);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleOpen = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setOpenRegistrationId(undefined);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClose = t3;
  let t4;
  if ($[5] !== isPending) {
    t4 = isPending && <Loading />;
    $[5] = isPending;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== error) {
    t5 = error && <ErrorComponent error={error} />;
    $[7] = error;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== displayOptions || $[10] !== insights || $[11] !== selectedSubsection) {
    t6 = (insights?.names || insights?.details) && selectedSubsection === "business-details" && <BusinessDetails names={insights.names} details={insights.details} onClick={handleOpen} displayOptions={displayOptions} />;
    $[9] = displayOptions;
    $[10] = insights;
    $[11] = selectedSubsection;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== displayOptions || $[14] !== insights || $[15] !== selectedSubsection) {
    t7 = insights?.people && selectedSubsection === "people" && <People data={insights.people} displayOptions={displayOptions} />;
    $[13] = displayOptions;
    $[14] = insights;
    $[15] = selectedSubsection;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== displayOptions || $[18] !== insights || $[19] !== selectedSubsection) {
    t8 = insights?.registrations && selectedSubsection === "registrations" && <Registrations data={insights.registrations} onClick={handleOpen} displayOptions={displayOptions} />;
    $[17] = displayOptions;
    $[18] = insights;
    $[19] = selectedSubsection;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== insights || $[22] !== selectedSubsection) {
    t9 = insights?.watchlist && selectedSubsection === "watchlist" && <Watchlist data={insights.watchlist} />;
    $[21] = insights;
    $[22] = selectedSubsection;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== insights || $[25] !== selectedSubsection) {
    t10 = insights?.addresses && selectedSubsection === "offices" && <Offices data={insights.addresses} />;
    $[24] = insights;
    $[25] = selectedSubsection;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== openRegistration) {
    t11 = !!openRegistration && <RegistrationDetails registration={openRegistration} onClose={handleClose} />;
    $[27] = openRegistration;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t12 = <>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
};
export default DecryptedContent;